module.exports = __webpack_public_path__ + "static/media/spinner.5fd2fe00.svg";